// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("../common/Components/Label.bs.js");
let React = require("react");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let AuthSession = require("../../utils/AuthSession.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__TextInput = require("../common/Components/Form__TextInput.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let AccountMemberUtils = require("./AccountMemberUtils.bs.js");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedTeamAccountProfileMemberRow_userMember_graphql = require("../../__generated__/UnifiedTeamAccountProfileMemberRow_userMember_graphql.bs.js");
let UnifiedTeamAccountProfileMemberRow_displayOnlyMember_graphql = require("../../__generated__/UnifiedTeamAccountProfileMemberRow_displayOnlyMember_graphql.bs.js");
let UnifiedTeamAccountProfileMemberRowMemberTitleMutation_graphql = require("../../__generated__/UnifiedTeamAccountProfileMemberRowMemberTitleMutation_graphql.bs.js");
let UnifiedTeamAccountProfileMemberRowMemberVisibilityMutation_graphql = require("../../__generated__/UnifiedTeamAccountProfileMemberRowMemberVisibilityMutation_graphql.bs.js");

let convertVariables = UnifiedTeamAccountProfileMemberRowMemberVisibilityMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedTeamAccountProfileMemberRowMemberVisibilityMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedTeamAccountProfileMemberRowMemberVisibilityMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedTeamAccountProfileMemberRowMemberVisibilityMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedTeamAccountProfileMemberRowMemberVisibilityMutation_graphql.node, convertResponse, convertWrapRawResponse);

let MemberVisibilityMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertVariables$1 = UnifiedTeamAccountProfileMemberRowMemberTitleMutation_graphql.Internal.convertVariables;

let convertResponse$1 = UnifiedTeamAccountProfileMemberRowMemberTitleMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = UnifiedTeamAccountProfileMemberRowMemberTitleMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, UnifiedTeamAccountProfileMemberRowMemberTitleMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, UnifiedTeamAccountProfileMemberRowMemberTitleMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let MemberTitleMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

function useMemberVisibility() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedMemberVisibility;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

function useMemberTitle() {
  let match = use$1();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedMemberTitle;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

function UnifiedTeamAccountProfileMemberRow$VisibilityBadge(props) {
  let match;
  let tmp = props.visibility;
  match = tmp === "HIDDEN" || tmp === "PUBLIC" ? (
      tmp === "HIDDEN" ? [
          "Hidden",
          "bg-zinc-100 text-zinc-700 ring-zinc-500/20"
        ] : [
          "Public",
          "bg-emerald-50 text-emerald-700 ring-emerald-600/20"
        ]
    ) : [
      "Unknown",
      "bg-zinc-100 text-zinc-700 ring-zinc-500/20"
    ];
  return JsxRuntime.jsx("span", {
    children: match[0],
    className: `rounded-full px-2.5 py-1 text-sm font-medium ring-1 ring-inset ` + match[1]
  });
}

let VisibilityBadge = {
  make: UnifiedTeamAccountProfileMemberRow$VisibilityBadge
};

let convertFragment = UnifiedTeamAccountProfileMemberRow_userMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedTeamAccountProfileMemberRow_userMember_graphql.node, convertFragment, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedTeamAccountProfileMemberRow_userMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedTeamAccountProfileMemberRow_userMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(UnifiedTeamAccountProfileMemberRow_userMember_graphql.node, convertFragment, fRef);
}

let Fragment_accountMemberRole_decode = UnifiedTeamAccountProfileMemberRow_userMember_graphql.Utils.accountMemberRole_decode;

let Fragment_accountMemberRole_fromString = UnifiedTeamAccountProfileMemberRow_userMember_graphql.Utils.accountMemberRole_fromString;

let Fragment_profileMemberVisibility_decode = UnifiedTeamAccountProfileMemberRow_userMember_graphql.Utils.profileMemberVisibility_decode;

let Fragment_profileMemberVisibility_fromString = UnifiedTeamAccountProfileMemberRow_userMember_graphql.Utils.profileMemberVisibility_fromString;

let Fragment = {
  accountMemberRole_decode: Fragment_accountMemberRole_decode,
  accountMemberRole_fromString: Fragment_accountMemberRole_fromString,
  profileMemberVisibility_decode: Fragment_profileMemberVisibility_decode,
  profileMemberVisibility_fromString: Fragment_profileMemberVisibility_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$2,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function UnifiedTeamAccountProfileMemberRow$User(props) {
  let canManageVisibility = props.canManageVisibility;
  let member = RescriptRelay_Fragment.useFragment(UnifiedTeamAccountProfileMemberRow_userMember_graphql.node, convertFragment, props.member);
  let currentUserId = AuthSession.useCurrentUserId();
  let match = useMemberVisibility();
  let saveVisibility = match[0];
  let match$1 = useMemberTitle();
  let saveTitle = match$1[0];
  let saving = match[1] || match$1[1];
  let match$2 = React.useState(() => Stdlib_Option.getOr(member.title, ""));
  let setTitle = match$2[1];
  let title = match$2[0];
  let match$3 = React.useState(() => false);
  let setEditingTitle = match$3[1];
  let editingTitle = match$3[0];
  return JsxRuntime.jsxs("li", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "h-12 w-12 flex-none rounded-full bg-zinc-50 object-cover",
                alt: member.agent.displayName + ` profile picture`,
                src: Stdlib_Option.getOr(Stdlib_Option.map(member.agent.profilePhoto, photo => photo.url), AvatarSrcUrl.placeholder)
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: member.agent.displayName,
                    className: "break-words font-semibold leading-6 text-zinc-800"
                  }),
                  JsxRuntime.jsx("p", {
                    children: AccountMemberUtils.roleOutputToString(member.role),
                    className: "text-sm text-zinc-500"
                  }),
                  Stdlib_Option.getOr(Stdlib_Option.map(member.title, title => JsxRuntime.jsx("p", {
                    children: `Title: ` + title,
                    className: "break-words text-sm text-zinc-500"
                  })), null)
                ],
                className: "min-w-0 flex-1"
              })
            ],
            className: "flex min-w-0 items-start gap-3"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(UnifiedTeamAccountProfileMemberRow$VisibilityBadge, {
              visibility: member.visibility
            }),
            className: "pt-1"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              canManageVisibility ? JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: param => saveVisibility({
                      memberNodeId: member.nodeId,
                      visibility: member.visibility !== "PUBLIC"
                    }, () => {}, param => {}),
                    disabled: saving,
                    size: "small",
                    className: "w-full lg:w-auto",
                    children: member.visibility === "PUBLIC" ? "Hide" : "Show publicly"
                  }),
                  className: "flex justify-end"
                }) : null,
              editingTitle ? null : JsxRuntime.jsx("div", {
                  children: canManageVisibility || currentUserId === member.agent.id ? JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                      onClick: param => {
                        setTitle(param => Stdlib_Option.getOr(member.title, ""));
                        setEditingTitle(param => true);
                      },
                      disabled: saving,
                      size: "small",
                      className: "w-full lg:w-auto",
                      children: Stdlib_Option.getOr(member.title, "") === "" ? "Add title" : "Edit title"
                    }) : null,
                  className: "col-start-2 flex justify-end"
                })
            ],
            className: "col-span-2 grid grid-cols-2 items-start gap-2 lg:col-span-1 lg:grid-cols-[7rem_4.5rem]"
          })
        ],
        className: "grid grid-cols-[minmax(0,1fr)_5rem] items-start gap-x-4 gap-y-3 lg:grid-cols-[minmax(0,1fr)_5rem_12rem]"
      }),
      editingTitle ? JsxRuntime.jsxs("form", {
          children: [
            JsxRuntime.jsx(Form__Label.make, {
              labelText: "Profile title"
            }),
            JsxRuntime.jsx(Form__TextInput.make, {
              onChange: event => setTitle(param => event.target.value),
              value: title
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                  disabled: saving,
                  size: "small",
                  children: "Save title"
                }),
                JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                  onClick: event => {
                    event.preventDefault();
                    setEditingTitle(param => false);
                    setTitle(param => Stdlib_Option.getOr(member.title, ""));
                  },
                  disabled: saving,
                  size: "small",
                  _type: "button",
                  children: "Cancel"
                })
              ],
              className: "flex flex-wrap gap-3"
            })
          ],
          className: "space-y-3 rounded-md bg-zinc-50 p-4",
          onSubmit: event => {
            event.preventDefault();
            saveTitle({
              memberNodeId: member.nodeId,
              title: title
            }, () => setEditingTitle(param => false), param => {});
          }
        }) : null,
      match[2],
      match$1[2]
    ],
    className: "space-y-4 py-5"
  });
}

let User = {
  Fragment: Fragment,
  make: UnifiedTeamAccountProfileMemberRow$User
};

let convertFragment$1 = UnifiedTeamAccountProfileMemberRow_displayOnlyMember_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedTeamAccountProfileMemberRow_displayOnlyMember_graphql.node, convertFragment$1, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedTeamAccountProfileMemberRow_displayOnlyMember_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedTeamAccountProfileMemberRow_displayOnlyMember_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(UnifiedTeamAccountProfileMemberRow_displayOnlyMember_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$3,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function UnifiedTeamAccountProfileMemberRow$DisplayOnly(props) {
  let member = RescriptRelay_Fragment.useFragment(UnifiedTeamAccountProfileMemberRow_displayOnlyMember_graphql.node, convertFragment$1, props.member);
  return JsxRuntime.jsxs("li", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "h-12 w-12 flex-none rounded-full bg-zinc-50 object-cover",
            alt: member.displayName + ` profile picture`,
            src: Stdlib_Option.getOr(Stdlib_Option.map(member.profilePicture, photo => photo.url), AvatarSrcUrl.placeholder)
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: member.displayName,
                className: "break-words font-semibold leading-6 text-zinc-800"
              }),
              JsxRuntime.jsx("p", {
                children: Stdlib_Option.getOr(member.title, "No title"),
                className: "text-sm text-zinc-500"
              })
            ],
            className: "min-w-0"
          })
        ],
        className: "flex min-w-0 items-start gap-3"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Label.Neutral.make, {
          text: "Display-only"
        }),
        className: "pt-1"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          href: `/account/account_profile/members/` + member.nodeId + `/edit`,
          size: "small",
          className: "col-start-2 w-full lg:w-auto lg:justify-self-end",
          children: "Edit"
        }),
        className: "col-span-2 grid grid-cols-2 gap-2 lg:col-span-1 lg:grid-cols-[7rem_4.5rem]"
      })
    ],
    className: "grid grid-cols-[minmax(0,1fr)_6rem] items-start gap-x-4 gap-y-3 py-5 lg:grid-cols-[minmax(0,1fr)_5rem_12rem]"
  });
}

let DisplayOnly = {
  Fragment: Fragment$1,
  make: UnifiedTeamAccountProfileMemberRow$DisplayOnly
};

exports.MemberVisibilityMutation = MemberVisibilityMutation;
exports.MemberTitleMutation = MemberTitleMutation;
exports.useMemberVisibility = useMemberVisibility;
exports.useMemberTitle = useMemberTitle;
exports.VisibilityBadge = VisibilityBadge;
exports.User = User;
exports.DisplayOnly = DisplayOnly;
/* commitMutation Not a pure module */
